import React from 'react';
import styles from './styles.scss';

class HorizontalScroll extends React.Component {
  initialState = {
    width: 0,
    showNav: true,
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.scrollContainer = React.createRef();
  }

  componentDidMount = () => {
    window.addEventListener('resize', this.updateDimensions);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.children !== this.props.children) {
      // timeout is added to ensure that all the children are inserted in the DOM alredy
      // should be refactored in the future - probably. by adding event listener on child width change
      // which equals 0 at the very beginning and then is changed
      setTimeout(this.showNav, 500);
      this.updateDimensions();
    }
  };

  componentWillUnmount = () => window.removeEventListener('resize', this.updateDimensions);

  updateDimensions = () => this.setState({ width: this.scrollContainer.current.children[0].offsetWidth });

  showNav = () => {
    const container = this.scrollContainer.current;

    this.setState({
      showNav: container.offsetWidth < container.children[0].offsetWidth * container.children.length,
    });
  };

  handleNextClick = () => (this.scrollContainer.current.scrollLeft += this.state.width);

  handlePrevClick = () => (this.scrollContainer.current.scrollLeft -= this.state.width);

  handleScroll = e => {
    const multiplier = e.deltaMode === 1 ? 16 : 1;

    this.scrollContainer.current.scrollLeft += e.deltaY * multiplier;
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles['scroll-navigation']} style={{ visibility: this.state.showNav ? 'visible' : 'hidden' }}>
          <div className={styles.prev} onClick={this.handlePrevClick}>
            <span />
            Prev
          </div>
          <div className={styles.next} onClick={this.handleNextClick}>
            Next
            <span />
          </div>
        </div>
        <div className={styles.container}>
          <div ref={this.scrollContainer} onWheel={this.handleScroll} className={styles.innerContent}>
            {this.props.children}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default HorizontalScroll;



// WEBPACK FOOTER //
// ./src/components/HorizontalScroll/index.js